var _style, _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClipboard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 283.5 283.5",
    style: {
      enableBackground: "new 0 0 283.5 283.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F09065;}\n\t.st1{fill:#22384E;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:#EBBD64;}\n\t.st4{fill:#AECBBC;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 141.4,
    cy: 141.5,
    r: 119.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M184.1,221.7h-87c-7,0-12.6-5.6-12.6-12.6V90.2c0-7,5.6-12.6,12.6-12.6h87c7,0,12.6,5.6,12.6,12.6v118.9 C196.7,216,191.1,221.7,184.1,221.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M180.9,212.9h-80.5c-4.5,0-8.1-3.6-8.1-8.1V95.5c0-4.5,3.6-8.1,8.1-8.1h80.5c4.5,0,8.1,3.6,8.1,8.1v109.2 C189,209.2,185.4,212.9,180.9,212.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M123.4,130.6h-16.6c-3.2,0-5.8-2.6-5.8-5.8v-16.6c0-3.2,2.6-5.8,5.8-5.8h16.6c3.2,0,5.8,2.6,5.8,5.8v16.6 C129.3,128,126.7,130.6,123.4,130.6z M106.8,105.4c-1.5,0-2.8,1.2-2.8,2.8v16.6c0,1.5,1.2,2.8,2.8,2.8h16.6c1.5,0,2.8-1.2,2.8-2.8 v-16.6c0-1.5-1.2-2.8-2.8-2.8H106.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M123.8,112.2l-2-2c-0.2-0.2-0.5-0.2-0.7,0l-7.8,7.6l-4-4c-0.2-0.2-0.5-0.2-0.7,0l-2,2c-0.2,0.2-0.2,0.5,0,0.7 l6.4,6.3c0.2,0.2,0.5,0.2,0.7,0l1.5-1.4c0,0,0,0,0,0l0.2-0.2l0.3-0.3c0,0,0,0,0,0l8.1-7.9C123.9,112.7,123.9,112.4,123.8,112.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M123.4,164.3h-16.6c-3.2,0-5.8-2.6-5.8-5.8v-16.6c0-3.2,2.6-5.8,5.8-5.8h16.6c3.2,0,5.8,2.6,5.8,5.8v16.6 C129.3,161.7,126.7,164.3,123.4,164.3z M106.8,139.1c-1.5,0-2.8,1.2-2.8,2.8v16.6c0,1.5,1.2,2.8,2.8,2.8h16.6c1.5,0,2.8-1.2,2.8-2.8 v-16.6c0-1.5-1.2-2.8-2.8-2.8H106.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M123.8,145.9l-2-2c-0.2-0.2-0.5-0.2-0.7,0l-7.8,7.6l-4-4c-0.2-0.2-0.5-0.2-0.7,0l-2,2c-0.2,0.2-0.2,0.5,0,0.7 l6.4,6.3c0.2,0.2,0.5,0.2,0.7,0l1.5-1.4c0,0,0,0,0,0l0.2-0.2l0.3-0.3c0,0,0,0,0,0l8.1-7.9C123.9,146.4,123.9,146.1,123.8,145.9z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M123.4,198h-16.6c-3.2,0-5.8-2.6-5.8-5.8v-16.6c0-3.2,2.6-5.8,5.8-5.8h16.6c3.2,0,5.8,2.6,5.8,5.8v16.6 C129.3,195.3,126.7,198,123.4,198z M106.8,172.7c-1.5,0-2.8,1.2-2.8,2.8v16.6c0,1.5,1.2,2.8,2.8,2.8h16.6c1.5,0,2.8-1.2,2.8-2.8 v-16.6c0-1.5-1.2-2.8-2.8-2.8H106.8z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M123.8,179.6l-2-2c-0.2-0.2-0.5-0.2-0.7,0l-7.8,7.6l-4-4c-0.2-0.2-0.5-0.2-0.7,0l-2,2c-0.2,0.2-0.2,0.5,0,0.7 l6.4,6.3c0.2,0.2,0.5,0.2,0.7,0l1.5-1.4c0,0,0,0,0,0l0.2-0.2l0.3-0.3c0,0,0,0,0,0l8.1-7.9C123.9,180.1,123.9,179.8,123.8,179.6z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 137.4,
    y: 105.6,
    className: "st4",
    width: 13.8,
    height: 4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 137.4,
    y: 114.8,
    className: "st4",
    width: 42,
    height: 4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 137.4,
    y: 123.9,
    className: "st4",
    width: 42,
    height: 4
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 137.4,
    y: 140.5,
    className: "st4",
    width: 13.8,
    height: 4
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 137.4,
    y: 149.6,
    className: "st4",
    width: 42,
    height: 4
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 137.4,
    y: 158.8,
    className: "st4",
    width: 42,
    height: 4
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 137.4,
    y: 175.3,
    className: "st4",
    width: 13.8,
    height: 4
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 137.4,
    y: 184.5,
    className: "st4",
    width: 42,
    height: 4
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 137.4,
    y: 193.7,
    className: "st4",
    width: 42,
    height: 4
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 106.4,
    y: 65.5,
    className: "st4",
    width: 68.8,
    height: 22
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 140.8,
    cy: 61,
    r: 11.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 140.8,
    cy: 61,
    r: 6.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboard);
export default __webpack_public_path__ + "static/media/Clipboard.430e1865529ea3ea1f6ebcc8ce3759cc.svg";
export { ForwardRef as ReactComponent };